/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaTextareaField/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.module.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaTextareaField({
  children,
  viewPath = "/DesignSystem/TysiaTextarea/TysiaTextareaField",
  autoFocus,
  resize,
  paddingTop = 5,
  paddingRight = 16,
  paddingBottom = 5,
  paddingLeft = 16,
  innerRef,
  height,
  placeholder,
  onChange,
  onBlur,
  onFocus,
  onKeyUp,
  value,
  disabled,
  maxLength,
  size
  
}) {
let dtTysiainputfieldColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputField.color.primary.base'
        })
  return (<React.Fragment
>
<textarea
  data-testid="TysiaTextareaField.CaptureTextArea"
  data-view-path={viewPath}
 autoFocus={autoFocus}
 ref={innerRef}
 placeholder={placeholder}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onBlur={onBlur}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 value={value}
 disabled={disabled}
 maxLength={maxLength}
 style={{'--r-1-JSTWK': resize,'--c-2-JSTWK': dtTysiainputfieldColorPrimaryBase,'--pt-5-JSTWK': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pr-6-JSTWK': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pb-7-JSTWK': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-8-JSTWK': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--h-9-JSTWK': typeof height === 'number' ? `${height}px` : height,'--fs-3-JSTWK': size == "small" ? "12px" : "13px",'--lh-4-JSTWK': size == "small" ? "16px" : "20px"}}
 className={`views-capture ${styles.CaptureTextArea}`}
/>
{children}
</React.Fragment>)
}